// Connexion Phomnikey — branchement sur la PORTE COMMUNE (2026-10-02), partie NAVIGATEUR.
//
// Le protocole (PKCE, échange du code, entrée silencieuse, renouvellement du jeton, garde
// anti-boucle, verrou contre deux relances simultanées) n'est plus recopié ici : il est servi par
// le hub, `https://id.etikpharma.com/flotte/porte.js`, chargé par index.html. Ce fichier ne garde
// que ce qui est PROPRE au Bureau : le jeton envoyé en Bearer à l'Edge Function, son stockage
// (session.js, testé), et l'écran de connexion.
//
// CE QUE ÇA CHANGE : le Bureau s'ouvre sans clic si l'appareil a une session Phomnikey, et le
// jeton est renouvelé avant sa fin (avant : relance d'une connexion complète toutes les ~55 min,
// sur le premier 401). Les corrections B3 (deux connexions simultanées) et B4 (code rejoué au F5)
// vivent désormais dans la porte, pour toute la flotte.
import { browserStore, tokenCourant, ecrireSession, effacerSession } from "./session.js";

const APP = "bureau"; // identifiant déclaré dans etikid.apps
const store = browserStore();
const porte = () => (window.Phomnikey ? window.Phomnikey.porte({ app: APP }) : null);
const INDISPONIBLE = "Phomnikey ne répond pas pour l’instant. Réessayez dans un instant.";

let TOKEN = tokenCourant(store);

export function jeton() {
  return TOKEN;
}

function poser(at) {
  TOKEN = at;
  ecrireSession(store, at);
}

/** Date de fin du jeton (secondes epoch), lue dans le jeton lui-même — 0 si illisible. */
function finDe(jwt) {
  try {
    return JSON.parse(atob(jwt.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))).exp || 0;
  } catch {
    return 0;
  }
}

/** Affiche un message sur l'écran de connexion, et montre ou non le bouton. */
function statutGate(msg, montrerBouton) {
  const s = document.getElementById("gate-status");
  if (s) s.textContent = msg || "";
  const b = document.getElementById("gate-login-btn");
  if (b) b.style.display = montrerBouton ? "block" : "none";
}

/** Le bouton « Se connecter » : retour au hub. */
export async function allerVersEtikid() {
  const p = porte();
  if (!p) {
    statutGate(INDISPONIBLE, true);
    return false;
  }
  void p.relancer();
  return true;
}

/** Le jeton a été refusé (401 de l'Edge Function) : on l'efface et on repasse par le hub — en
 *  silence si la session Phomnikey vit. Une seule relance part, même sur plusieurs 401 (verrou de
 *  la porte). */
export function relancerConnexion() {
  effacerSession(store);
  TOKEN = "";
  return allerVersEtikid();
}

/** Sortie : efface le jeton du Bureau, et empêche la ré-entrée silencieuse dans cet onglet. */
export function seDeconnecter() {
  effacerSession(store);
  TOKEN = "";
  const p = porte();
  if (p) p.oublier();
  location.replace(location.pathname);
}

/**
 * Point d'entrée : entrée silencieuse, retour du hub, ou jeton encore bon en poche.
 * `auMontage` est appelée quand une session utilisable est disponible.
 */
export async function demarrerGate(auMontage) {
  const p = porte();
  if (!p) {
    // Script du hub injoignable : un jeton encore valide suffit à travailler.
    if (TOKEN) auMontage();
    else statutGate(INDISPONIBLE, true);
    return;
  }
  statutGate("Connexion…", false);
  try {
    const e = await p.entrer({ enPoche: TOKEN ? { jeton: TOKEN, expireA: finDe(TOKEN) } : null });
    if (e.jeton) poser(e.jeton);
    auMontage();
    p.entretenir({ expiresIn: e.expiresIn, onJeton: (x) => x.jeton && poser(x.jeton) });
  } catch (err) {
    statutGate(err && err.code === "clic" ? "" : (err && err.message) || INDISPONIBLE, true);
  }
}
